export default [{"url":"https://theshopes-0.api.invexone.com","name":"HQ","port":"6510","isStore":true,"isHQ":true}]